import EventHandler from "../utils/EventHandler";
import getCookie from "../utils/getCookie";
import setCookie from "../utils/setCookie";
import ScrollLock from "../utils/ScrollLock";
import trackEvent from '../utils/trackEvent';

export default class StaticExitIntent {
  constructor(section) {
    this.el = section.el;
    this.data = section.data;
    this.ev = new EventHandler();

    this.productAtc = document.querySelector('.section-product [data-product-submit]')
    this.popup = this.el.querySelector('.exit-intent-popup');
    this.timeouts = [];

    if (!this.popup || !this.productAtc || getCookie('exitIntentShown')) {
      return;
    }

    this.addExitEventHandlers = this.addExitEventHandlers.bind(this);
    this.showExitIntentPopup = this.showExitIntentPopup.bind(this);
    this.exitIntentMouseEvent = this.exitIntentMouseEvent.bind(this);
    this.closePopupEvent = this.closePopupEvent.bind(this);

    this.ev.register(this.productAtc, 'click', this.addExitEventHandlers);
  }

  showExitIntentPopup() {
    if (getCookie('exitIntentShown')) {
      return;
    }

    this.io = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        if (this.data.isInvisible) {
          trackEvent('ExitIntentInvisibleImpression', { productHandle: this.data.productHandle, productVendor: this.data.productVendor })
          this.popup.classList.remove('show');
        } else {
          trackEvent('ExitIntentImpression', { productHandle: this.data.productHandle, productVendor: this.data.productVendor })
        }
        this.io.disconnect();
      }
    }, {
      threshold: 1.0
    });

    this.io.observe(this.popup);

    // Set the cookie when the popup is shown to the user
    setCookie('exitIntentShown', true, this.data.showAgainDays);

    this.popup.classList.add('show');
    if (this.data.isInvisible) {
      return;
    }
    this.popup.scrollTop;
    this.popup.classList.add('visible');

    this.ev.register(document, 'keydown', this.closePopupEvent);
    this.ev.register(this.popup, 'click', this.closePopupEvent);
    ScrollLock.lock(this.popup);

    this.ev.register(this.el.querySelector('.call-to-action'), 'click', () => {
      trackEvent('ExitIntentClick', { productHandle: this.data.productHandle, productVendor: this.data.productVendor })
    });
  };

  exitIntentMouseEvent(e) {
    const shouldShowExitIntent =
      !e.toElement &&
      !e.relatedTarget &&
      e.clientY < 10;

    if (shouldShowExitIntent) {
      this.ev.unregister(document, 'mouseout', this.exitIntentMouseEvent);

      this.timeouts.push(setTimeout(() => {
        this.showExitIntentPopup();
      }, this.data.delayTime * 1000));
    }
  };

  closePopupEvent(e) {
    const shouldExit =
      [...e.target.classList].includes('exit-intent-popup') || // user clicks on mask
      e.target.classList.contains('close') || // user clicks on the close icon
      e.target.closest('.close') || // user clicks on the close icon
      e.keyCode === 27; // user hits escape

    if (shouldExit) {
      ScrollLock.unlockAll();
      this.popup.classList.remove('show');
      this.popup.classList.remove('visible');
    }
  };

  addExitEventHandlers() {
    this.ev.register(document, 'mouseout', this.exitIntentMouseEvent);
    this.ev.register(window, 'visibilitychange', (e) => {
      if (document.visibilityState === 'hidden') {
        this.showExitIntentPopup();
      }
    });

    this.timeouts.push(setTimeout(() => {
      this.showExitIntentPopup();
    }, this.data.exitTime * 1000));

    this.ev.unregister(this.productAtc, 'click', this.addExitEventHandlers);
  };

  onSectionUnload() {
    this.ev.unregisterAll();
    this.timeouts.forEach((timeout) => clearTimeout(timeout));
    this.io && this.io.disconnect();
  }
}
